// Copyright (c) 2020 JCA Electronics , Winnipeg, MB. All rights reserved.

// Colors for MultiMachine polygons
export enum MultiMachinePolygonColors {
  Boundary = '#008000',
  TruckZones = '#00ffff',
  SelectedTruckZone = '#008b8b',
  Obstacles = '#ff0000',
  PriorityCorridors = '#0000ff',
  ReducedSpeedAreas = '#ff6500',
  UserCoverage = '#ffd801'
}
